import {
  AdminInsurerDetailTemplate,
  LoadingTemplate,
  SiteAdminNotFoundTemplate,
} from '@/components/templates';
import { useGetInsurerDetail } from '@/hooks/admin';
import { useParams } from 'react-router-dom';

const SiteAdminInsurerDetailPage = () => {
  const { site, id } = useParams<{ site: string; id: string }>();
  const currentSite = site ?? 'medix';

  const breadcrumbItems = [
    {
      title: '保険者',
      href: `/${currentSite}/admin/insurers`,
    },
    {
      title: `詳細:${id}`,
    },
  ];

  const { data: insurerDetail, status } = useGetInsurerDetail();

  if (status === 'pending') return <LoadingTemplate />;

  if (status === 'error') return <SiteAdminNotFoundTemplate />;

  return (
    <main>
      <AdminInsurerDetailTemplate breadcrumbItems={breadcrumbItems} data={insurerDetail} />
    </main>
  );
};

export default SiteAdminInsurerDetailPage;
